import {Row} from "react-bootstrap";
import PropTypes from "prop-types";

export function Section(props) {
    const {children, className} = props;
    return <Row className={'g-0 ' + className}>
        {children}
    </Row>
}

Section.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string
};